import { parseDomain } from 'helpers/parseDomain';
import * as moment from 'moment-business-days';
import * as $ from 'jquery';

import {
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { AuthService } from 'services/auth.service';
import { CartService } from 'services/cart.service';
import { OrderService } from 'services/order.service';
import { DialogService } from 'services/dialog.service';
import { BugsnagService } from 'services/bugsnag.service';
import { EcommerceService } from 'services/ecommerce.service';
import { CheckoutService } from 'components/checkout/checkout.service';

import accountHtml from './account.html';
import './account.scss';

@Component({
  selector: 'gw-portal-checkout-account',
  template: accountHtml,
})
export class CheckoutAccountComponent implements OnInit {
  public FS = (<any>window).FS;
  public GW = (<any>window).GW;
  public fbq = (<any>window).fbq;
  public laroute = (<any>window).laroute;

  public customerForm;
  public cart = this.GW.cart;
  public order = this.orderService.order;
  public state = {
    submitting: false,
  };
  public departureDate;
  public minDepartureDate;
  public maxDepartureDate;
  public datepickerOpened = false;
  public remarketing = this.GW.remarketing;

  constructor(
    @Inject('$log') private $log,
    @Inject('$filter') private $filter,
    @Inject(AuthService) private authService: AuthService,
    @Inject(CartService) private cartService: CartService,
    @Inject(OrderService) private orderService: OrderService,
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(BugsnagService) private bugsnagService: BugsnagService,
    @Inject(CheckoutService) private checkoutService: CheckoutService,
    @Inject(EcommerceService) private ecommerceService: EcommerceService,
  ) {}

  /**
   * Component init hook
   */
  ngOnInit() {
    // Send event to Facebook Pixel
    if (typeof this.fbq === 'function') {
      this.fbq('track', 'InitiateCheckout');
    }

    // departureDate initialization
    const destinationId = Object.keys(this.cart.itinerary.destinations)[0];
    this.departureDate = this.cart.itinerary.destinations[destinationId].dates !== null &&
      this.cart.itinerary.destinations[destinationId].dates.hasOwnProperty('startDate')
      ? this.cart.itinerary.destinations[destinationId].dates.startDate
      : null;
    this.minDepartureDate = moment().add(1, 'days').toDate();
    this.maxDepartureDate = moment().add(5, 'years').toDate();

    this.ecommerceService.checkout(2, this.cart);
  }

  /**
   * Trigger open user sign in dialog
   *
   * @param {Event} $event
   * @memberof UserAuthComponent
   */
  async openSignIn($event: Event) {
    try {
      const dialog: any = await this.dialogService.openUserAuth({}, $event);

      // If login was successful, reload page
      if (dialog && dialog.reload) {
        window.location.reload();
      }
    } catch (e) {
      throw e;
    }
  }

  async submitForm() {
    // Is form valid?
    if (this.customerForm.$invalid) {
      return;
    }

    this.state.submitting = true;

    // Register some user values to
    // if (this.FS && this.FS.setUserVars) {
    //   this.FS.identify(this.order.account.email, {
    //     displayName: `${this.order.account.firstName} ${this.order.account.lastName}`,
    //   });
    // }

    // Don't need to check users since it will be using ETOMS
    // try {
    //   const user: any = await this.authService
    //     .userExists(this.order.account.email);

    //   if (user.data.exists) {
    //     this.state.submitting = false;

    //     return this.dialogService.openAlert({
    //       icon: '/img/errors/user-exists.svg',
    //       title: 'User already exists',
    //       text: `An account with this email address already exists. Please try signing in.
    //         <a href="${ process.env.MIX_MYGOVWORKS }/#!/forgot" target="_blank">
    //           Did you forget your password?
    //         </a>`,
    //     });
    //   }
    // } catch (e) {
    //   this.state.submitting = false;
    //   this.$log.error('Error checking if user exists', e);
    //   return this.dialogService.openAlert({});
    // }

    try {
      if (this.departureDate) {
        const destinationId = Object.keys(this.cart.itinerary.destinations)[0];
        this.cart = await this.cartService
          .setDestinationStartDate(destinationId, moment(this.departureDate).format('MM/DD/YYYY'));
      }
      const hotlead = this.createHotlead();
      const response: any = await this.authService.hotlead(hotlead);
      if (response.status === 'success') {
        this.order.account.salesleadId = response.data.saleslead_id;
        this.order.account.applicantId = response.data.applicant_id;
        this.order.account.primaryApplicantId = response.data.primary_applicant_id;
        this.order.account.sessionId = response.data.session_id;
        this.orderService.updateAccount(this.order.account);
      }
    } catch (e) {
      this.state.submitting = false;
      this.$log.error('Error creating hotlead', e);
      return this.dialogService.openAlert({});
    }

    // Send  event to Facebook Pixel
    if (typeof this.fbq === 'function') {
      this.fbq('track', 'Lead', {
        value: this.cartService.getOrderTotal(),
        currency: 'USD',
      });
    }

    // Next page
    window.location.assign(this.laroute.route('checkout.shipping'));
  }

  createHotlead() {
    // Base it off new order payload
    const leadPayload = this.checkoutService
      .getNewOrderPayload(this.cart, this.order, {});

    // Add FullStory session URL if available
    if (this.FS && typeof this.FS.getCurrentSessionURL === 'function') {
      leadPayload.full_story_url = this.FS.getCurrentSessionURL();
    }

    if (this.remarketing) {
      leadPayload['remarketing'] = this.remarketing;
    }
    return leadPayload;
  }

  async sendProof() {
    return this.authService.sendProof(this.order.account, this.GW.geoip);
  }

  /**
   * A dirty fix to open the dropdown on click and on focus
   */
  datepickerFix() {
    $('.gw-md-datepicker input')
      .prop('autocomplete', 'off')  // not tested
      .on('click', (event) => {
        this.datepickerOpened = true;
      });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/account/account.component.ts